import { render, staticRenderFns } from "./RatingProfessorIndex.vue?vue&type=template&id=577e89fe"
import script from "./RatingProfessorIndex.vue?vue&type=script&lang=js"
export * from "./RatingProfessorIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports